import BlogPreview from "./BlogPreview";

export default BlogPreview;